import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/feature-tags`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/feature-tags/${id}`);
  },
  async findAll() {
    return axios.get(`/feature-tags`);
  },
  async delete({ id }) {
    return axios.delete(`/feature-tags/${id}`);
  },
  async update(formData) {
    return axios.put(`/feature-tags/${formData.id}`, formData);
  },
  async updateAdminOrder(formData) {
    return axios.put(`/feature-tags/${formData.id}/order-admin`, formData);
  },
  async updateWebsiteOrder(formData) {
    return axios.put(`/feature-tags/${formData.id}/order-website`, formData);
  }
};
